/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Adapter } from '@seek/tealium-adapter';

export const mockTealiumAdapter: Adapter = {
  link: (_: string | string[], __: Record<string, any>) => {},
  view: (_: string, __: Record<string, any>) => {},
};
